import React from 'react';
import { Link } from 'react-router-dom';
import { constructorWhatsapp } from '../utils/utils';

const TerminosServicios = () => {
  const currentYear = new Date().getFullYear(); // Renderiza dinámicamente el año actual (2026)

  return (
    <div className="w-full bg-slate-50 min-h-screen py-12 px-6 lg:px-16 text-left text-slate-700 font-sans">
      <div className="max-w-4xl mx-auto bg-white rounded-[2rem] p-8 md:p-12 shadow-sm border border-slate-200/60 space-y-8 animate-fadeIn">
        
        {/* ENCABEZADO */}
        <div className="border-b border-slate-100 pb-6">
          <h1 className="text-3xl md:text-4xl font-black text-slate-900 tracking-tight">
            Términos y Condiciones de Servicio
          </h1>
          <p className="text-sm text-slate-400 font-bold uppercase tracking-wider mt-2">
            Contrato de Prestación de Servicios Académicos • Vigencia: {currentYear}
          </p>
        </div>

        {/* INTRODUCCIÓN */}
        <p className="text-sm md:text-base leading-relaxed font-medium text-slate-600">
          El presente documento constituye un acuerdo legal y vinculante entre el usuario (en adelante, "El Cliente") y <span className="font-bold text-slate-900">Dufy Asesorías</span>. Al solicitar, cotizar o contratar cualquiera de nuestros servicios de soporte, desarrollo de talleres o tutorías académicas en tiempo real, El Cliente declara conocer, comprender y aceptar la totalidad de las cláusulas aquí estipuladas.
        </p>

        {/* SECCIÓN 1 */}
        <div className="space-y-3">
          <h2 className="text-xl font-extrabold text-slate-900 tracking-tight flex items-center gap-2">
            <span className="text-blue-600">1.</span> Naturaleza del Servicio y Deslinde de Responsabilidad
          </h2>
          <p className="text-sm leading-relaxed font-medium">
            Dufy Asesorías provee servicios de consultoría, desarrollo de guías ilustrativas y tutorías especializadas con fines de acompañamiento y refuerzo académico privado. 
          </p>
          <p className="text-sm leading-relaxed font-medium">
            El Cliente es el único responsable de la gestión, uso y presentación final del material académico suministrado ante su respectiva institución educativa. Dufy Asesorías no se hace responsable por sanciones de carácter institucional, pérdida de beneficios o fallos normativos internos derivados del uso inapropiado del soporte contratado.
          </p>
        </div>

        {/* SECCIÓN 2 */}
        <div className="space-y-3">
          <h2 className="text-xl font-extrabold text-slate-900 tracking-tight flex items-center gap-2">
            <span className="text-blue-600">2.</span> Metodología de Pago y Liquidación
          </h2>
          <p className="text-sm leading-relaxed font-medium">
            Para dar inicio a cualquier trámite de asignación de tutores expertos, El Cliente deberá acogerse a una de nuestras dos modalidades vigentes:
          </p>
          <ul className="list-disc pl-5 text-sm font-semibold text-slate-600 space-y-2">
            <li>
              <strong className="text-slate-800">Pago Completo:</strong> Liquidación del 100% del valor cotizado antes del inicio del servicio. Esta modalidad es estrictamente obligatoria para todas las solicitudes que involucren exámenes de modalidad presencial.
            </li>
            <li>
              <strong className="text-slate-800">Pago Dividido:</strong> Abono del 50% inicial para reservar el cupo del docente experto, y el 50% restante a la mitad del tiempo establecido de la prueba o contra entrega del avance parcial documentado.
            </li>
          </ul>
        </div>

        {/* SECCIÓN 3 */}
        <div className="space-y-4">
          <h2 className="text-xl font-extrabold text-slate-900 tracking-tight flex items-center gap-2">
            <span className="text-blue-600">3.</span> Políticas Estrictas de Cancelación, Incumplimiento y Cambios
          </h2>
          <p className="text-sm leading-relaxed font-medium">
            Para proteger el tiempo reservado de nuestro cuerpo de docentes especializados, se aplican de forma estricta las siguientes penalidades económicas ante modificaciones unilaterales por parte de El Cliente:
          </p>
          
          {/* Tabla de condiciones estilizada */}
          <div className="grid grid-cols-1 gap-3.5 max-w-3xl">
            <div className="bg-red-50 border border-red-100 p-4 rounded-xl text-xs md:text-sm font-bold text-red-900">
              <span className="text-red-600 block uppercase text-[11px] tracking-wider mb-1">Caso 1: Imposibilidad de envío en examen presencial</span>
              Si el examen es presencial y El Cliente no logra enviar las preguntas o imágenes al tutor al momento de rendirlo: Se reembolsará únicamente el 50% del valor cobrado, reteniéndose el resto por concepto de reserva del docente.
            </div>
            
            <div className="bg-emerald-50 border border-emerald-100 p-4 rounded-xl text-xs md:text-sm font-bold text-emerald-900">
              <span className="text-emerald-600 block uppercase text-[11px] tracking-wider mb-1">Caso 2: Cancelación con anticipación (Mayor a 24 horas)</span>
              Si El Cliente cancela el servicio solicitado con más de 24 horas de antelación al evento: Se otorgará un reembolso del 80% del costo total.
            </div>

            <div className="bg-orange-50 border border-orange-100 p-4 rounded-xl text-xs md:text-sm font-bold text-orange-900">
              <span className="text-orange-600 block uppercase text-[11px] tracking-wider mb-1">Caso 3: Cancelación tardía (Menor a 24 horas)</span>
              Si El Cliente cancela el servicio con menos de 24 horas de antelación: Se reembolsará el 50% del depósito y se cobrará el saldo restante comprometido.
            </div>

            <div className="bg-blue-50 border border-blue-100 p-4 rounded-xl text-xs md:text-sm font-bold text-blue-900">
              <span className="text-blue-600 block uppercase text-[11px] tracking-wider mb-1">Caso 4: Reprogramación de fecha u hora</span>
              Si El Cliente requiere cambiar la fecha o la hora acordada para su evaluación: Se aplicará de forma obligatoria una multa del 20% sobre el costo total del servicio.
            </div>
          </div>
        </div>

        {/* SECCIÓN 4 */}
        <div className="space-y-3">
          <h2 className="text-xl font-extrabold text-slate-900 tracking-tight flex items-center gap-2">
            <span className="text-blue-600">4.</span> Canales de Comunicación y Logística por WhatsApp
          </h2>
          <p className="text-sm leading-relaxed font-medium">
            Toda la entrega de soporte y asistencia en tiempo real se ejecutará de forma privada e intransferible. El grupo exclusivo de soporte en WhatsApp que vincula a El Cliente con su tutor asignado se creará formalmente un día antes de la fecha programada de la prueba, estrictamente en la franja horaria comprendida entre las <span className="font-bold text-slate-900">10:30 pm y las 11:30 pm</span>. El Cliente debe estar atento para validar su ingreso.
          </p>
        </div>

        {/* SECCIÓN 5 */}
        <div className="space-y-3">
          <h2 className="text-xl font-extrabold text-slate-900 tracking-tight flex items-center gap-2">
            <span className="text-blue-600">5.</span> Política de Garantía Total del Dinero
          </h2>
          <p className="text-sm leading-relaxed font-medium">
            En Dufy Asesorías respaldamos la calidad de nuestro equipo docente. Si tras procesarse la entrega o asistencia técnica, la calificación final obtenida por El Cliente resulta ser <span className="text-red-600 font-bold">menor al 60% de la nota máxima</span> permitida en la rúbrica del servicio evaluado, nos comprometemos a ejecutar el reembolso íntegro del <span className="text-emerald-600 font-black">100% de tu dinero</span> sin trabas administrativas.
          </p>
        </div>

        {/* SECCIÓN 6 */}
        <div className="space-y-3">
          <h2 className="text-xl font-extrabold text-slate-900 tracking-tight flex items-center gap-2">
            <span className="text-blue-600">6.</span> Modificaciones del Acuerdo
          </h2>
          <p className="text-sm leading-relaxed font-medium">
            Dufy Asesorías se reserva el derecho de actualizar, modificar o alterar las presentes condiciones comerciales en cualquier momento para ajustarse a nuevas normativas o requerimientos del mercado operativo. Es responsabilidad de El Cliente revisar este apartado de forma periódica.
          </p>
        </div>

        {/* PIE DE PÁGINA INTERNO */}
        <div className="border-t border-slate-100 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="text-xs text-slate-400 font-semibold space-y-1 text-center sm:text-left">
            <p>© {currentYear} Dufy Asesorías. Todos los derechos reservados.</p>
            <p>Si tienes dudas sobre este contrato, por favor contáctanos.</p>
          </div>
          
          <div className="flex items-center gap-2">
            {/* Usamos tu constructor de WhatsApp para dudas de soporte */}
            <a 
              href={constructorWhatsapp("573161585420", "Hola, tengo una pregunta técnica sobre los Términos de Servicio.")}
              target="_blank"
              rel="noreferrer"
              className="text-slate-500 hover:text-slate-900 font-bold text-xs px-4 py-2.5 rounded-xl border border-slate-200 transition-colors"
            >
              Soporte Legal
            </a>
            <Link 
              to="/" 
              className="bg-slate-900 hover:bg-blue-600 text-white font-extrabold text-xs px-5 py-2.5 rounded-xl transition-colors shadow-sm"
            >
              Aceptar e Ir al Inicio
            </Link>
          </div>
        </div>

      </div>
    </div>
  );
};

export default TerminosServicios;